const needsUpdateListeners = Symbol("Tracker.needsUpdateListeners");
const needsUpdate = Symbol("Tracker.needsUpdate");
const isUpdating = Symbol("Tracker.isUpdating");

const emptyCallback = () => {};

class Tracker {
    constructor() {
        this[needsUpdateListeners] = new Set();
        this[needsUpdate] = false;
        this[isUpdating] = false;
    }

    listenNeedsUpdate(callback) {
        this[needsUpdateListeners].add(callback);
    }

    unlistenNeedsUpdate(callback) {
        this[needsUpdateListeners].delete(callback);
    }

    get needsUpdate() {
        return this[needsUpdate];
    }

    protected_needsUpdate(needs = true) {
        needs = Boolean(needs);

        if (this[needsUpdate] === needs) {
            return;
        }

        this[needsUpdate] = needs;

        if (needs) {
            for (const callback of this[needsUpdateListeners]) {
                callback(this);
            }
        }
    }

    protected_startUpdate() {
        throw new Error("Method .protected_update is not implemented");
    }

    protected_finishUpdate() {
        throw new Error("Method .protected_finishUpdate is not implemented");
    }

    startUpdate() {
        if (this[isUpdating]) {
            throw new Error("Called .startUpdate while updating");
        }

        this[isUpdating] = true;
        return this.protected_startUpdate();
    }

    finishUpdate() {
        if (!this[isUpdating]) {
            throw new Error("Called .finishUpdate while not updating");
        }

        this.protected_finishUpdate();

        this[needsUpdate] = false;
        this[isUpdating] = false;
    }

    update(callback = emptyCallback) {
        callback(this.startUpdate());
        this.finishUpdate();
    }

    updateIfNeeded(callback = emptyCallback) {
        if (this[needsUpdate]) {
            this.update(callback);
        }
    }
}

export default Tracker;
